module.exports = __webpack_public_path__ + "static/media/software.84115a9e.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/software.svg
// module id = 138
// module chunks = 0